export default __webpack_public_path__ + "static/media/HON.e38b13c8.svg";